import { Button } from '@mui/material';
import { MessageError, useWithMessage } from 'probonio-shared-ui/module/error';
import { all } from 'probonio-shared-ui/module/error/MessageError';
import React, { useCallback, useState } from 'react';

export const ErrorSimulator = (): React.JSX.Element => {
  const withOtherDefaultMessage = useWithMessage(all('super error '));
  const [fail, setFail] = useState(false);

  return (
    <>
      <Button
        variant="contained"
        onClick={useCallback(() => {
          void (async () => {
            throw new Error('An error');
          })().catch(withOtherDefaultMessage);
        }, [withOtherDefaultMessage])}
      >
        {'Catch with alternative default message'}
      </Button>

      <Button
        variant="contained"
        onClick={useCallback(() => {
          void (async () => {
            throw new Error('An error');
          })();
        }, [])}
      >
        {'Unhandled rejection'}
      </Button>

      <Button
        variant="contained"
        onClick={useCallback(() => {
          throw new Error('An error');
        }, [])}
      >
        {'Throw'}
      </Button>

      <Button
        variant="contained"
        onClick={useCallback(() => {
          throw new MessageError(new Error('An error'), 'super display message');
        }, [])}
      >
        {'Throw MessageError'}
      </Button>

      <Button
        variant="contained"
        onClick={useCallback(() => {
          setFail(true);
        }, [])}
      >
        {'Fail render'}
      </Button>

      {fail &&
        (() => {
          throw new Error('Render error');
        })()}
    </>
  );
};
